import Promotion from './module/promotion';
import PromotionGroup from './module/promotion-group';
import PromotionDetail from './module/promotion-detail';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import useAppStore from './app-store';
import { analytics } from './app-loader';

const RoutesGroup = ({ locationSearch }) => {
  return (
    <Routes>
      <Route index element={<Promotion locationSearch={locationSearch} />} />
      <Route path="/group/:groupId" element={<PromotionGroup />} />
      <Route path="/group/:groupId/index.html" element={<PromotionGroup />} />
      <Route path="/detail/:detailId" element={<PromotionDetail />} />
      <Route
        path="/detail/:detailId/index.html"
        element={<PromotionDetail />}
      />
    </Routes>
  );
};

const FeaturePromotion = ({
  app,
  nextModule,
  basePath,
  env,
  action = null,
  distributor,
  locationSearch,
}) => {
  const appStore = useAppStore();

  useEffect(() => {
    appStore.setApp(app);
    appStore.setBasePath(basePath);
    appStore.setNextModule(nextModule);
    if (action) appStore.setGlobalAction(action);
    if (env.analyticsKey) analytics.init(env.analyticsKey);
    if (env.userId) analytics.setUserId(env.userId);
    if (distributor) appStore.setDistributor(distributor);
  }, []);

  if (nextModule) {
    return (
      <BrowserRouter basename={basePath}>
        <RoutesGroup locationSearch={locationSearch} />
      </BrowserRouter>
    );
  }

  return <RoutesGroup locationSearch={locationSearch} />;
};

export default FeaturePromotion;
